import { transport } from 'config/transport';

export function callApiGetListOfGrades(params) {
    return transport.get('/mamnon/grades', params);
}
